/**
 *
 * @returns Array with country codes
 */
export const getCountryCodes = () => {
  return COUNTRY_OPTIONS.map((c) => c.code);
};

export const getCountriesAsSelectOptions = (language) => {
  let label, code;
  const options = COUNTRY_OPTIONS.map((c) => {
    code = c.code;
    if (c.code === "LAC") {
      label = "LAC";
    } else {
      label = language === "en" ? c.country_text_en : c.country_text;
    }

    return {
      value: code,
      label: label,
    };
  });

  return options;
};

export const COUNTRY_OPTIONS = [
  {
    name: "LAC",
    url: "",
    country: "region",
    country_text: "América Latina y el Caribe",
    country_text_en: "Latin America and the Caribbean",
    code: "LAC",
  },
  {
    name: "ARGENTINA",
    url: require("./../../images/argentina.jpg"),
    country: "argentina",
    country_text: "Argentina",
    country_text_en: "Argentina",
    code: "ARG",
    coor: {
      lat: -39.916097,
      long: -63.616672,
      zoom: 3.75,
    },
  },
  {
    name: "BARBADOS",
    url: require("./../../images/barbados.jpg"),
    country: "barbados",
    country_text: "Barbados",
    country_text_en: "Barbados",
    code: "BRB",
    coor: {
      lat: 13.193887,
      long: -59.543198,
      zoom: 10,
    },
  },
  {
    name: "BELICE",
    url: "",
    country: "belice",
    country_text: "Belice",
    country_text_en: "Belize",
    code: "BLZ",
    coor: {
      lat: 17.1907805,
      long: -88.3596575,
      zoom: 8,
    },
  },
  {
    name: "BOLIVIA",
    url: require("./../../images/bolivia.jpeg"),
    country: "bolivia",
    country_text: "Bolivia",
    country_text_en: "Bolivia",
    code: "BOL",
    coor: {
      lat: -16.290154,
      long: -63.588653,
      zoom: 5.5,
    },
  },
  {
    name: "BRASIL",
    url: require("./../../images/brasil.jpg"),
    country: "brasil",
    country_text: "Brasil",
    country_text_en: "Brazil",
    code: "BRA",
    coor: {
      lat: -14.235004,
      long: -51.92528,
      zoom: 3.75,
    },
  },
  {
    name: "CARIBE",
    url: "",
    country: "caribe",
    country_text: "Caribe",
    country_text_en: "Caribbean",
    code: "CARIBE",
    coor: {
      lat: 16.653248,
      long: -70.322954,
      zoom: 4.5,
    },
  },
  {
    name: "CHILE",
    url: require("./../../images/chile.jpg"),
    country: "chile",
    country_text: "Chile",
    country_text_en: "Chile",
    code: "CHL",
    coor: {
      lat: -35.675147,
      long: -71.542969,
      zoom: 4,
    },
  },
  {
    name: "COLOMBIA",
    url: require("./../../images/colombia.jpeg"),
    country: "colombia",
    country_text: "Colombia",
    country_text_en: "Colombia",
    code: "COL",
    coor: {
      lat: 4.570868,
      long: -74.297333,
      zoom: 5,
    },
  },
  {
    name: "COSTA RICA",
    url: require("./../../images/costarica.jpeg"),
    country: "costa_rica",
    country_text: "Costa Rica",
    country_text_en: "Costa Rica",
    code: "CRI",
    coor: {
      lat: 9.748917,
      long: -83.753428,
      zoom: 7.5,
    },
  },
  {
    name: "ECUADOR",
    url: require("./../../images/ecuador.jpeg"),
    country: "ecuador",
    country_text: "Ecuador",
    country_text_en: "Ecuador",
    code: "ECU",
    coor: {
      lat: -1.831239,
      long: -78.183406,
      zoom: 6.5,
    },
  },
  {
    name: "EL SALVADOR",
    url: require("./../../images/elsalvador.jpeg"),
    country: "el_salvador",
    country_text: "El Salvador",
    country_text_en: "El Salvador",
    code: "SLV",
    coor: {
      lat: 13.794185,
      long: -88.89653,
      zoom: 8.5,
    },
  },
  {
    name: "GUATEMALA",
    url: require("./../../images/guatemala.jpeg"),
    country: "guatemala",
    country_text: "Guatemala",
    country_text_en: "Guatemala",
    code: "GTM",
    coor: {
      lat: 15.783471,
      long: -90.230759,
      zoom: 7,
    },
  },
  {
    name: "HONDURAS",
    url: require("./../../images/honduras.jpeg"),
    country: "honduras",
    country_text: "Honduras",
    country_text_en: "Honduras",
    code: "HND",
    coor: {
      lat: 14.899999,
      long: -86.241905,
      zoom: 7.25,
    },
  },
  {
    name: "MÉXICO",
    url: require("./../../images/mexico.jpg"),
    country: "mexico",
    country_text: "México",
    country_text_en: "Mexico",
    code: "MEX",
    coor: {
      lat: 22.977,
      long: -99.539,
      zoom: 4.75,
    },
  },
  {
    name: "NICARAGUA",
    url: require("./../../images/nicaragua.jpeg"),
    country: "nicaragua",
    country_text: "Nicaragua",
    country_text_en: "Nicaragua",
    code: "NIC",
    coor: {
      lat: 12.865416,
      long: -85.207229,
      zoom: 7,
    },
  },
  {
    name: "PANAMÁ",
    url: require("./../../images/panama.jpg"),
    country: "panama",
    country_text: "Panamá",
    country_text_en: "Panama",
    code: "PAN",
    coor: {
      lat: 8.537981,
      long: -79.982127,
      zoom: 7.5,
    },
  },
  {
    name: "PARAGUAY",
    url: require("./../../images/paraguay.jpeg"),
    country: "paraguay",
    country_text: "Paraguay",
    country_text_en: "Paraguay",
    code: "PRY",
    coor: {
      lat: -23.442503,
      long: -58.443832,
      zoom: 6,
    },
  },
  {
    name: "PERÚ",
    url: require("./../../images/peru.jpeg"),
    country: "peru",
    country_text: "Perú",
    country_text_en: "Peru",
    code: "PER",
    coor: {
      lat: -9.189967,
      long: -75.015152,
      zoom: 5,
    },
  },
  {
    name: "REP. DOMINICANA",
    url: require("./../../images/repdominicana.jpeg"),
    country: "dominican_republic",
    country_text: "República Dominicana",
    country_text_en: "Dominican Republic",
    code: "DOM",
    coor: {
      lat: 18.735693,
      long: -70.162651,
      zoom: 7.75,
    },
  },
  {
    name: "TRINIDAD Y TOBAGO",
    url: require("./../../images/trinidadandtobago.jpg"),
    country: "trinidadytobago",
    country_text: "Trinidad y Tobago",
    country_text_en: "Trinidad and Tobago",
    code: "TTO",
    coor: {
      lat: 10.691803,
      long: -61.222503,
      zoom: 8.75,
    },
  },
  {
    name: "URUGUAY",
    url: require("./../../images/uruguay.jpeg"),
    country: "uruguay",
    country_text: "Uruguay",
    country_text_en: "Uruguay",
    code: "URY",
    coor: {
      lat: -32.522779,
      long: -55.765835,
      zoom: 6.5,
    },
  },
  {
    name: "VENEZUELA",
    url: require("./../../images/venezuela.jpg"),
    country: "venezuela",
    country_text: "Venezuela",
    country_text_en: "Venezuela",
    code: "VEN",
    coor: {
      lat: 6.42375,
      long: -66.58973,
      zoom: 5.5,
    },
  },
];
